import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

export default function ModeCard({ mode, onSelect }) {
  return (
    <div
      className="group relative flex flex-col rounded-2xl border transition-all duration-300 cursor-pointer overflow-hidden"
      style={{
        background: "var(--color-card)",
        borderColor: mode?.active ? "var(--color-primary)" : "var(--color-border)",
        boxShadow: mode?.active ? "var(--shadow-md)" : "var(--shadow-sm)",
      }}
      onClick={() => onSelect(mode)}
    >
      {mode?.badge && (
        <span
          className="absolute top-3 right-3 text-xs font-semibold px-2 py-0.5 rounded-full z-10"
          style={{ background: "var(--color-accent)", color: "var(--color-accent-foreground)" }}
        >
          {mode?.badge}
        </span>
      )}
      <div
        className="flex items-center justify-center w-full h-28 md:h-32 lg:h-36 rounded-t-2xl"
        style={{ background: mode?.gradient }}
      >
        <Icon name={mode?.icon} size={48} color="white" strokeWidth={1.5} />
      </div>
      <div className="flex flex-col flex-1 p-4 md:p-5 gap-2">
        <h3
          className="font-heading font-semibold text-base md:text-lg"
          style={{ color: "var(--color-foreground)" }}
        >
          {mode?.title}
        </h3>
        <p
          className="text-sm line-clamp-2 flex-1"
          style={{ color: "var(--color-muted-foreground)" }}
        >
          {mode?.description}
        </p>
        <div className="flex flex-wrap gap-1 mt-1">
          {mode?.tags?.map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-full"
              style={{ background: "var(--color-muted)", color: "var(--color-muted-foreground)" }}
            >
              {tag}
            </span>
          ))}
        </div>
        <Button
          variant="default"
          size="sm"
          iconName="ArrowRight"
          iconPosition="right"
          className="mt-3 w-full"
          onClick={(e) => { e?.stopPropagation(); onSelect(mode); }}
        >
          {mode?.cta}
        </Button>
      </div>
    </div>
  );
}